import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNegativeMask]'
})
export class NegativeMaskDirective {
  private readonly el: HTMLInputElement;

  constructor(elementRef: ElementRef<HTMLInputElement>) {
    this.el = elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let rawValue = this.el.value;

    // Se só tem "-" ou está vazio → deixa assim
    if (rawValue === '-' || rawValue.trim() === '') {
      return;
    }

    const isNegative = rawValue.startsWith('-');

    // Remove tudo que não seja número
    rawValue = rawValue.replace(/\D/g, '');

    if (!rawValue) {
      this.el.value = isNegative ? '-' : '';
      return;
    }

    // Converte em centavos
    const numericValue = parseFloat(rawValue) / 100;

    // Formata em pt-BR
    let formatted = numericValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (isNegative) {
      formatted = '-' + formatted;
    }

    this.el.value = formatted;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '-') {
      event.preventDefault();

      if (this.el.value.startsWith('-')) {
        // Remove o sinal
        this.el.value = this.el.value.replace('-', '');
      } else {
        // Adiciona sinal (mesmo que esteja vazio)
        this.el.value = '-' + this.el.value;
      }
    }
  }
}
